import { RadioGroup } from '@zep-us/zus';
import { type FirstPurchasePromotion } from '../utils/quoteCalculator';
import { formatDiscountRate, formatWon } from '../utils/quoteFormat';
import { type QuotePricingPolicy } from '../utils/quotePricingPolicy';
import { PlanTypeOption } from './PlanTypeOption';
import { QuoteSection } from './QuoteSection';

/**
 * 요금제 유형 — Basic 플랜 (Figma 15222-4427).
 *
 * Basic 은 학교·단체 할인 대상이 아니라 "개인" 한 가지뿐이라 Pro 의 2지선다
 * (PlanTypeSection)와 분리한다. 선택지가 하나라 항상 선택된 상태로 고정하고,
 * 첫 구매 할인 대상이면 할인 적용 단가를 안내한다.
 */
export function BasicPlanTypeSection({
  policy,
  firstPurchasePromotion,
  isDiscountApplicable = true
}: {
  policy: QuotePricingPolicy | null;
  firstPurchasePromotion: FirstPurchasePromotion | null;
  /**
   * 첫 구매 할인 대상인지. 기간이 `maxDiscountMonths`를 넘으면 초과분만 정가다.
   */
  isDiscountApplicable?: boolean;
}) {
  const discountRate = firstPurchasePromotion?.discountRate ?? 0;
  const isDiscounted = discountRate > 0;
  const showDiscountedPrice = isDiscounted && isDiscountApplicable;
  let unitAmount: number | null = null;
  if (policy) {
    unitAmount = policy.basicUnitAmount;
    if (showDiscountedPrice) {
      unitAmount = Math.floor(unitAmount * (1 - discountRate));
    }
  }
  let description: string | undefined;
  if (unitAmount !== null) {
    description = `인당 월 ${formatWon(unitAmount)}원`;
    if (showDiscountedPrice) {
      description += firstPurchasePromotion?.maxDiscountMonths ? ` (첫 ${firstPurchasePromotion.maxDiscountMonths}개월 할인)` : ' (첫 구매 할인)';
    }
  }
  return <QuoteSection title="요금제 유형" data-sentry-element="QuoteSection" data-sentry-component="BasicPlanTypeSection" data-sentry-source-file="BasicPlanTypeSection.tsx">
      <RadioGroup value="individual" className="gap-lg" data-sentry-element="RadioGroup" data-sentry-source-file="BasicPlanTypeSection.tsx">
        <PlanTypeOption value="individual" title="개인" badge={isDiscounted ? `${formatDiscountRate(discountRate)} 할인` : undefined} description={description} data-sentry-element="PlanTypeOption" data-sentry-source-file="BasicPlanTypeSection.tsx" />
      </RadioGroup>
    </QuoteSection>;
}